import React from 'react';

export interface AppCardContentProps {
    // Styling props
    extraClass?: string[];
    fullBlock?: boolean;

    // Content
    children?: React.ReactNode;
}

const AppCardContent: React.FC<AppCardContentProps> = ({
    // Styling props
    extraClass = [],
    fullBlock = false,

    // Content
    children
}) => {
    const classes = [fullBlock ? 'app-full-content' : 'app-card-content', ...extraClass].filter(Boolean).join(' ');

    return <div className={classes}>{children}</div>;
};

export default AppCardContent;
